/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListingStatusItem
 */
export interface ListingStatusItem {
    /**
     * 
     * @type {number}
     * @memberof ListingStatusItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ListingStatusItem
     */
    listingStatus: string;
}

/**
 * Check if a given object implements the ListingStatusItem interface.
 */
export function instanceOfListingStatusItem(value: object): value is ListingStatusItem {
    if (!('listingStatus' in value) || value['listingStatus'] === undefined) return false;
    return true;
}

export function ListingStatusItemFromJSON(json: any): ListingStatusItem {
    return ListingStatusItemFromJSONTyped(json, false);
}

export function ListingStatusItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingStatusItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'listingStatus': json['listingStatus'],
    };
}

export function ListingStatusItemToJSON(json: any): ListingStatusItem {
    return ListingStatusItemToJSONTyped(json, false);
}

export function ListingStatusItemToJSONTyped(value?: ListingStatusItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'listingStatus': value['listingStatus'],
    };
}

